import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import '../pagination/pagination.css';
import Pagination from '../pagination/pagination';
import LeaseApiService from '../../services/apiService';
import { RiRefreshLine } from 'react-icons/ri';
import { FaFileCircleExclamation } from 'react-icons/fa6';
import { IoAddSharp } from 'react-icons/io5';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import CreateUnitMaster from './createUnit';
import UpdateUnitMaster from './updateUnitMaster';
import ViewUnitMaster from './view';

const UnitListing = ({ releaseMode = false }) => {
  const apiService = new LeaseApiService();
  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [enteredBy, setEnteredBy] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);
  const [unitCategoryList, setunitCategoryList] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [pagination, setPagination] = useState();
  const [FilterTab, setFilterTab] = useState(true);
  const [propertyList, setpropertyList] = useState([]);
  const [contextMenu, setContextMenu] = useState(null);
  const [releasing, setReleasing] = useState(false);
  const [releaseConfirmRow, setReleaseConfirmRow] = useState(null);
  const [modalMode, setModalMode] = useState(null); // null | 'add' | 'edit' | 'view'
  const [modalRow, setModalRow] = useState(null);

  const [formData, setFormData] = useState({
    unitNo: '',
    unitMdal: '',
    UnitClass: '',
    propertyName: null,
    unitType: null,
    unitCategory: null,
    enteredBy: null,
  });

  const [permissions, setPermissions] = useState([]);
  useEffect(() => {
    getItems()
    const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
    const permissions = storedPermissions?.filter(acc => acc.formName === "Unit Master RA");
    setPermissions(permissions[0]);
  }, []);

  useEffect(() => {
    const handleClickOutside = () => setContextMenu(null);
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    const loadPropertyDropdown = async () => {
      try {
        const params = new URLSearchParams();
        params.append('dropdownTypes', 'UMProperties,UMUnitTypes,UMUnitCategories,UMEnteredBy');
        const res = await apiService.getApiParamater('UNIT_RA_MULTIDROP', `?${params.toString()}`);
        setpropertyList(res?.data?.dropdowns?.umproperties || []);
        setEnteredBy(res?.data?.dropdowns?.umenteredBy);
        setUnitTypeList(res?.data?.dropdowns?.umunitTypes);
        setunitCategoryList(res?.data?.dropdowns?.umunitCategories);

      } catch (e) {
        console.error('Error loading property list:', e);
      }
    };
    loadPropertyDropdown();
    getItems();
  }, []);

  const getItems = async (newPageNo = pagination?.currentPage) => {
    try {
      const params = new URLSearchParams();
      params.append('PageNo', newPageNo || 1);
      params.append('PageSize', pageSize || 20);
      params.append('PropertyNo', formData?.propertyName?.value?.value || '');
      params.append('UnitNo', formData?.unitNo || '');
      params.append('UnitClass', formData?.UnitClass || '');
      params.append('UnitType', formData?.unitType?.label || '');
      params.append('UnitCategory', formData?.unitCategory?.label || '');
      params.append('CreatedBy', formData?.enteredBy?.label || '');
      params.append('UnitModel', formData?.unitMdal || '');
      const res = await apiService.getApiParamater('GET_UNIT_RA_LIST', `?${params.toString()}`);
      setLoading(false);
      setRowData(res?.data?.result || []);
      setPagination(res.data.paginationData);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };
  const columnDefs = [
    {
      headerName: '',
      field: 'scheduleId',
      cellRenderer: BtnCellRenderer,
      pinned: 'left',
      cellRendererParams: {
        clicked: function (field, scheduleId) {
          handleMenuAction(field, scheduleId);
        },
      },
      width: 30,
    },
    { headerName: 'Ref no', field: 'ref_No', filter: true, floatingFilter: true, suppressMovable: true, width: 150, pinned: 'left' },
    { headerName: 'Property Name', field: 'property_Name', filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
    { headerName: 'Unit No', field: 'unit_No', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit Type', field: 'unit_Type', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit Category', field: 'unit_Category', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit Class', field: 'unit_Class', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Status', field: 'status', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'BedRooms', field: 'bedrooms', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Total Area', field: 'total_Area', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Floor', field: 'floor', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit View', field: 'unit_View', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Rate / Sqft', field: 'sqft_Rate', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Rent / Annum', field: 'rent_Per_Annum', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Property No', field: 'property_No', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
  ];
  const handleMenuAction = (action, rowData) => {
    switch (action) {
      case 'edit':
        handleEdit(rowData);
        break;
      case 'release':
        openReleaseConfirm(rowData);
        break;
      case 'view':
        handleView(rowData);
        break;
      default:
        break;
    }
    setContextMenu(null);
  };
  const handleEdit = (rowData) => {
    setModalRow(rowData);
    setModalMode('edit');
  };
  const handleView = (rowData) => {
    setModalRow(rowData);
    setModalMode('view');
  };
  const closeModal = () => {
    setModalMode(null);
    setModalRow(null);
    getItems();
  };
  const openReleaseConfirm = (rowData) => {
    const refNo = rowData?.ref_No;
    if (!refNo) {
      toast.warning('Release no is missing');
      return;
    }
    setReleaseConfirmRow(rowData);
  };
  const closeReleaseConfirm = () => {
    if (!releasing) setReleaseConfirmRow(null);
  };
  const confirmRelease = async () => {
    const refNo = releaseConfirmRow?.ref_No;
    if (!refNo) return;

    try {
      setReleasing(true);
      const res = await apiService.put('RELEASE_UNIT_BLOCKING', {
        refNo,
        releasedDate: new Date().toISOString(),
      });
      if (res?.data?.isSuccessful || res?.data?.result === true) {
        toast.success(res?.data?.message || 'Unit released successfully');
        setReleaseConfirmRow(null);
        getItems(pagination?.currentPage || 1);
      } else {
        toast.warning(res?.data?.message || 'Release failed');
      }
    } catch (error) {
      console.error('Error releasing unit:', error);
      toast.error(error?.response?.data?.message || 'Failed to release unit');
    } finally {
      setReleasing(false);
    }
  };
  const handleClearFilters = () => {
    setFormData({
      unitNo: '',
      unitMdal: '',
      UnitClass: '',
      propertyName: null,
      unitType: null,
      unitCategory: null,
      enteredBy: null,
    });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleDropDownChange = async ({ name, value }) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handlenew = () => {
    setModalRow(null);
    setModalMode('add');
  };
  return (
    <div className="p-3">
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setFilterTab(!FilterTab)}>
          <div className="h6 pt-1">Search Parameters</div>
        </div>
        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
          <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
            <div className="form-group grid-contain ">
              <div className="d-flex">
                <label className="form-label pt-2 start">Property Name</label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.propertyName}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'propertyName', value: selectedOption })}
                  options={propertyList?.map((prop) => ({ value: prop, label: prop?.text }))}
                />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Unit Type</label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.unitType}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'unitType', value: selectedOption })}
                  options={unitTypeList?.map((prop) => ({ value: prop, label: prop?.text }))}
                />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Unit Category</label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.unitCategory}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'unitCategory', value: selectedOption })}
                  options={unitCategoryList?.map((prop) => ({ value: prop, label: prop?.text }))}
                />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Unit No</label>
                <input type="text" className="p-2 form-control w-75" name="unitNo" value={formData.unitNo} onChange={handleInputChange} />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Entered By</label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.enteredBy}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'enteredBy', value: selectedOption })}
                  options={enteredBy?.map((prop) => ({ value: prop, label: prop?.text }))}
                />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Unit Class</label>
                <input type="text" className="p-2 form-control w-75" name="UnitClass" value={formData.UnitClass} onChange={handleInputChange} />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Unit Model</label>
                <input type="text" className="p-2 form-control w-75" name="unitMdal" value={formData.unitMdal} onChange={handleInputChange} />
              </div>
              <div className="d-flex gap-1">
                <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-50">
                  <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                  <div className="center">Search</div>
                </div>
                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                  <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                  <div className="center">Reset</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-box2 p-3">
        {loading ? (
          <div>Loading...</div>
        ) : (
          <>
            <div className="d-flex justify-contant-between ">
              <h5 className="col mainInvHead">{releaseMode ? 'Unit Release' : 'Unit Listing'}</h5>
              {!releaseMode && (
                <div className="d-flex justify-content-end gap-1">
                  {permissions?.canAdd === true ?
                    <div className="col center">
                      <button className="mainbtn " type="submit" onClick={() => handlenew()}>
                        <IoAddSharp color="#fff" className="center mt-1" /> <div>Add</div>
                      </button>
                    </div>
                    : ""}
                </div>
              )}
            </div>
            <div className="gridshad  mt-2">
              <div className="ag-theme-quartz" style={{ height: 650 }}>
                <AgGridReact
                  getRowStyle={(params) => {
                    if (params.node.rowIndex % 2 === 0) {
                      return { background: '#F0EDF5' };
                    } else {
                      return { background: '#fff' };
                    }
                  }}
                  rowData={rowData}
                  enableFilter={true}
                  floatingFilter={true}
                  columnDefs={columnDefs}
                  frameworkComponents={{ BtnCellRenderer }}
                  context={{ setContextMenu }}
                />
              </div>
              <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
          </>
        )}
        {contextMenu && (
          <div
            style={{
              position: 'absolute',
              top: contextMenu.mouseY,
              left: contextMenu.mouseX,
              backgroundColor: 'white',
              border: '1px solid gray',
              zIndex: 1000,
              padding: '10px 10px',
              borderRadius: '8px',
              boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
            }}
          >
            <div className="d-flex flex-column gap-1">
              {releaseMode ? (
                <>
                  {permissions?.canView === true ?
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleMenuAction('view', contextMenu.data)}>
                      View
                    </button>
                    : ""}
                  <button type="button" className="btn btn-sm btn-primary" disabled={releasing} onClick={() => handleMenuAction('release', contextMenu.data)}>
                    Release
                  </button>
                </>
              ) : (
                <>
                  {permissions?.canUpdate === true ?
                    <button type="button" className="btn btn-sm btn-primary" onClick={() => handleMenuAction('edit', contextMenu.data)}>
                      Edit
                    </button> : ""
                  }
                  {permissions?.canView === true ?
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleMenuAction('view', contextMenu.data)}>
                      View
                    </button> : ""
                  }
                </>
              )}
            </div>
          </div>
        )}
        <Modal show={!!releaseConfirmRow} onHide={closeReleaseConfirm} centered>
          <Modal.Body className="text-center p-4">
            <p className="mb-4">Do you want to release the &quot;{releaseConfirmRow?.ref_No}&quot;?</p>
            <div className="d-flex justify-content-center gap-3">
              <button type="button" className="btn btn-primary px-4" disabled={releasing} onClick={confirmRelease}>
                Yes
              </button>
              <button type="button" className="btn btn-secondary px-4" disabled={releasing} onClick={closeReleaseConfirm}>
                Cancel
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={modalMode !== null}
          onHide={closeModal}
          backdrop="static"
          keyboard={false}
          centered
          dialogClassName="unit-form-modal"
          contentClassName="p-0"
        >
          <Modal.Body style={{ padding: 0 }}>
            {modalMode === 'add' && <CreateUnitMaster onClose={closeModal} />}
            {modalMode === 'edit' && <UpdateUnitMaster rowData={modalRow} onClose={closeModal} />}
            {modalMode === 'view' && <ViewUnitMaster rowData={modalRow} onClose={closeModal} />}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};
export default UnitListing;
class BtnCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.stopPropagation(); // Prevent row selection
    const { context, data } = this.props;

    if (context && context.setContextMenu) {
      context.setContextMenu({
        mouseX: e.clientX,
        mouseY: e.clientY,
        data: data,
      });
    }
  }

  render() {
    return (
      <div className="center pt-1">
        <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '25px' }}>
          &#8942; {/* Vertical Ellipsis */}
        </span>
      </div>
    );
  }
}
